<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-08-28 16:15:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-03-18 16:48:14
 -->
<template>
  <div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  props: {
    //   当前页数
     currentPage: {
        type: Number,
        default: 1
     },
    //  一页数据条数
     pageSize: {
        type: Number,
        default: 10
     },
    //  数据总数
     totalSize : {
        type: Number,
        default: 0
     }
  },

  created() {},

  methods: {
    // 获取每页条数
    handleSizeChange(val) {
      this.$emit('pageSizeChange', val)
      console.log(`每页 ${val} 条`)
    },
    // 获取当前页数
    handleCurrentChange(val) {
      this.$emit('pageChange', val)
      console.log(`当前页: ${val}`)
    }
  }
}
</script>
<style lang='scss' scoped>
.page {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/base/page/index.vue